import React from 'react';
import get from 'lodash.get';
import { connect } from 'react-redux';

// components
import {
  Element,
  Color,
  FontType,
  MobileCardDetailHeader,
  Typography
} from '@americanexpress/aqx-components';
import DynamicAppLeftRail from './DynamicAppLeftRail/index.js';
import YourCardBadge from 'src/universal/components/YourCardBadge';
import AmazonDisclaimer from '../../../business-vac/components/AmazonDisclaimer';

// selectors
import { getTopHeroData, supportUpgradeCta } from 'page_modules/business-pdp/redux';
import { shouldShowDynamicAppPDP } from 'page_modules/business-pdp/redux';

// utils
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { buildCtaList, buildDisclaimerList } from 'page_modules/business-pdp/utils';

//styles
import dynamicAppStyles from './DynamicAppLeftRail/__styles__/index.scss?modules';
import styles from './__styles__/mobileHeader.scss?modules';
import { isG171Experiment } from 'src/universal/components/Experiments/G171/redux.js';

export const MobileHeader = ({
  pageDispatch,
  topHeroData,
  hasUpgradeCta,
  showDynamicApp,
  isG171
}) => {
  const { cardData, labels, links, cardInfo, backImgUrl } = topHeroData;
  const ctaProps = buildCtaList({
    cardInfo,
    links,
    dispatch: pageDispatch,
    labels,
    isG171
  });

  const cardTitle = (
    <>
      <Typography
        Component="h1"
        $family={FontType.BentonBold}
        $size="18px"
        $lineHeight="135%"
        theme={{
          color: Color.DeepBlue
        }}
      >
        <Sanitizer safelySetInnerHTML={cardData?.cardHeadlines?.longTitle} />
      </Typography>
      <YourCardBadge shortName={cardData?.shortName} isMobilePdp={true} />
    </>
  );

  const dataProps = {
    title: cardTitle,
    subtitle: null,
    cardArtUrl: get(cardData, 'appAssets.cardArt') || '',
    fee: {
      header: labels.annualFee,
      text: `  ${get(cardData, 'annualFee') || ''}`
    },
    backgroundImage: backImgUrl,
    ctas: showDynamicApp ? [] : ctaProps,
    disclaimerLinks: buildDisclaimerList(links, 'Header', hasUpgradeCta),
    contentBeforeCTAComponent: showDynamicApp ? (
      <DynamicAppLeftRail
        ctaProps={ctaProps}
        hasUpgradeCta={hasUpgradeCta}
        styles={dynamicAppStyles}
      />
    ) : (
      <></>
    ),
    contentAfterCTA: <AmazonDisclaimer shortName={cardData?.shortName} />
  };

  return (
    <Element className={styles.mobileHeaderOuter}>
      <MobileCardDetailHeader qeId="gcsMobileHeader" data={dataProps} />
    </Element>
  );
};

const mapStateToProps = (state, ownProps) => {
  const urlEep = get(ownProps, 'params.eep') || '';
  return {
    topHeroData: getTopHeroData(urlEep)(state),
    hasUpgradeCta: supportUpgradeCta(state),
    showDynamicApp: shouldShowDynamicAppPDP(state),
    isG171: isG171Experiment(state)
  };
};

export default connect(mapStateToProps)(React.memo(MobileHeader));
